import { render, staticRenderFns } from "./LoadedPolygonsTargetOption.vue?vue&type=template&id=12c48e52"
import script from "./LoadedPolygonsTargetOption.vue?vue&type=script&lang=ts"
export * from "./LoadedPolygonsTargetOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports